/* 布局 */
//前台
import Layout from "@views/layout";

const ordergravelatticeRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
        {
        path: "ordergravelattice/list",
        name: "ORDERGRAVELATTICE",
        meta: {
            title: "格位寄存订单",
            keepAlive:true
        },
        component: () => import("@views/business/ordergravelattice/index.vue"),
    },
        ],
};

export default ordergravelatticeRouter;
